import { Component, Input, OnInit } from '@angular/core';
import { Onboarding } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-success-hero',
  templateUrl: './alg-success-hero.component.html',
  styleUrls: ['./alg-success-hero.component.scss'],
})
export class AlgSuccessHeroComponent implements OnInit {
  public currentOnboarding: Onboarding = {} as Onboarding;

  @Input() compact: boolean = false;

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.api.currentOnboarding.subscribe((onboarding: Onboarding) => {
      this.currentOnboarding = onboarding;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-success-hero/alg-success-hero.component.ts